import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

const SuccessSnackbar = (props) => {
  const { t } = useTranslation();

  const {
    dialog,
    handleClose = (f) => f,
    handleSubmit = (f) => f,
    // children,
    // closeBtn = true,
  } = props;
  const {
    open,
    sectionText = '',
    confirmBtnTitle = t('확인'),
    cancelBtnTitle = t('취소'),
    confirmBtnOpen = true,
    cancelBtnOpen = true,
  } = dialog;

  return (
    <div>
      <Dialog open={open} keepMounted onClose={handleClose}>
        {/* <DialogTitle id="alert-dialog-slide-title"></DialogTitle> */}
        <DialogContent>{sectionText}</DialogContent>
        <DialogActions>
          {cancelBtnOpen && (
            <Button onClick={handleClose} color="primary">
              {cancelBtnTitle}
            </Button>
          )}
          {confirmBtnOpen && (
            <Button onClick={handleSubmit} color="primary">
              {confirmBtnTitle}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default SuccessSnackbar;
